/**
 * The one way to reach us: the platform's Telegram channel.
 *
 * About & legal points every "tell us" here — a misused account, a paper
 * someone believes is theirs, a question about personal information.
 */
export const TELEGRAM_URL = 'https://t.me/+wBSp-Fc_etlkODg6';
